import { Navigate } from 'react-router-dom';
import { ROUTE_PATHS } from 'routes';

export default function ProtectedRoute({ children }) {
  const accessToken = localStorage.getItem('token');

  const accessUserInfo = localStorage.getItem('user');

  const notAuthenticated = !accessToken || !accessUserInfo;

  if (notAuthenticated) {
    return <Navigate to={ROUTE_PATHS.DEFAULT} />;
  }

  return !!accessToken && children;
}
